export default {
  methods: {
    showConfirm (text, icon = 'warning') {
      return this.$swal({
        title: '',
        text: text || 'Are you sure?',
        type: icon,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK',
        cancelButtonText: 'CANCEL'
      })
    },

    showMessage (text, icon) {
      return this.$swal({
        title: '',
        text: text,
        type: icon,
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK',
      })
    }
  }
};
